import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Lock, Mail, ArrowLeft } from 'lucide-react';
import { useAuth } from './AuthContext';
export function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const {
    login
  } = useAuth();
  const navigate = useNavigate();
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Mock login
    if (email && password) {
      login();
      navigate('/admin');
    }
  };
  return <div className="min-h-screen bg-cream flex items-center justify-center p-4 font-body relative overflow-hidden" data-id="element-450">
      {/* Decorative background elements */}
      <div className="absolute top-[-10%] right-[-5%] w-[40%] h-[40%] bg-sage/10 rounded-full blur-[80px] pointer-events-none" data-id="element-451" />
      <div className="absolute bottom-[-10%] left-[-5%] w-[40%] h-[40%] bg-sand/80 rounded-full blur-[80px] pointer-events-none" data-id="element-452" />

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="bg-white p-8 md:p-10 rounded-3xl shadow-xl border border-mist w-full max-w-md relative z-10" data-id="element-453">
        <div className="text-center mb-8" data-id="element-454">
          <h1 className="font-display text-3xl font-bold text-earth mb-2" data-id="element-455">
            Vimutti Admin
          </h1>
          <p className="text-stone text-sm" data-id="element-456">
            Ingresa tus credenciales para continuar
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5" data-id="element-457">
          <div data-id="element-458">
            <label className="block text-sm font-semibold text-earth mb-2" data-id="element-459">
              Email
            </label>
            <div className="relative" data-id="element-460">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-461">
                <Mail className="h-5 w-5 text-stone/50" data-id="element-462" />
              </div>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} className="w-full pl-10 p-3 border-2 border-mist rounded-xl text-sm outline-none transition-all focus:border-sage focus:ring-4 focus:ring-sage/10" placeholder="admin@vimuttiyoga.com" required data-id="element-463" />
            </div>
          </div>

          <div data-id="element-464">
            <label className="block text-sm font-semibold text-earth mb-2" data-id="element-465">
              Contraseña
            </label>
            <div className="relative" data-id="element-466">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-467">
                <Lock className="h-5 w-5 text-stone/50" data-id="element-468" />
              </div>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)} className="w-full pl-10 p-3 border-2 border-mist rounded-xl text-sm outline-none transition-all focus:border-sage focus:ring-4 focus:ring-sage/10" placeholder="••••••••" required data-id="element-469" />
            </div>
          </div>

          <button type="submit" className="w-full bg-earth text-cream py-3.5 rounded-xl font-semibold hover:bg-earth/90 transition-colors mt-2 shadow-sm" data-id="element-470">
            Iniciar Sesión
          </button>
        </form>

        <div className="mt-6 text-center" data-id="element-471">
          <button onClick={() => navigate('/')} className="text-sm text-stone hover:text-sage transition-colors flex items-center justify-center gap-2 mx-auto" data-id="element-472">
            <ArrowLeft size={16} data-id="element-473" /> Volver al sitio principal
          </button>
        </div>
      </motion.div>
    </div>;
}